module.exports = __webpack_public_path__ + "assets/8a4532320b6f90a4821dc6b1f5daed24.png";